import { Link } from 'react-router-dom'
import { SEO } from '@/components/layout/SEO'
import { Btn } from '@/components/ui'
import { C } from '@/constants/theme'

export default function NotFound() {
  return (
    <>
      <SEO title="Page Not Found" description="This page doesn't exist." path="/404" />
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: C.grayLight, paddingTop: 68 }}>
        <div style={{ textAlign: 'center', padding: '0 24px' }}>
          <div style={{ fontFamily: "'Rajdhani', sans-serif", fontSize: 120, fontWeight: 700, color: C.blue, lineHeight: 1, opacity: 0.15 }}>404</div>
          <div style={{ fontFamily: "'Rajdhani', sans-serif", fontSize: 32, fontWeight: 700, color: C.text, marginBottom: 12, marginTop: -20 }}>Page Not Found</div>
          <div style={{ color: C.textMid, fontSize: 15, marginBottom: 32 }}>The page you're looking for doesn't exist.</div>
          <Link to="/" style={{ textDecoration: 'none' }}><Btn>Back to Home</Btn></Link>
        </div>
      </div>
    </>
  )
}
